import React from "react";
import SectionHead from "./SectionHead";

const SkillsSection = () => (
  <section className="teach" aria-labelledby="teach-title">
    <div className="wrap">
      <SectionHead
        number="02"
        title="The skills"
        emphasis="school forgot."
        id="teach-title"
      />
      <p className="teach-lead">
        The shiny tech changes every six months.{" "}
        <strong>The skills that build careers do not.</strong>
      </p>
      <div className="teach-grid">
        <div className="skill-card">
          <div className="skill-icon">
            <svg viewBox="0 0 24 24">
              <use href="#ic-brain" />
            </svg>
          </div>
          <h3>Behavioural Science &amp; Psychology</h3>
          <p>
            Understand why people (including you) actually decide what they
            decide. The single most useful lens you can put on the world.
          </p>
        </div>
        <div className="skill-card">
          <div className="skill-icon">
            <svg viewBox="0 0 24 24">
              <use href="#ic-leadership" />
            </svg>
          </div>
          <h3>Leadership &amp; Wellbeing</h3>
          <p>
            How to lead yourself first, then others. Plus the science of staying
            happy and well in a world that won't sit still.
          </p>
        </div>
        <div className="skill-card">
          <div className="skill-icon">
            <svg viewBox="0 0 24 24">
              <use href="#ic-strategy" />
            </svg>
          </div>
          <h3>Marketing, Strategy &amp; Sales</h3>
          <p>
            How brands are built, how strategy actually works, and how to tell a
            story people want to hear. Useful well beyond marketing.
          </p>
        </div>
        <div className="skill-card">
          <div className="skill-icon">
            <svg viewBox="0 0 24 24">
              <use href="#ic-ai-spark" />
            </svg>
          </div>
          <h3>AI &amp; Innovation</h3>
          <p>
            Not which buttons to press, but the thinking that helps you use
            whatever technology exists this year, next year, and the one after.
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default SkillsSection;
